import React, { Component } from 'react';
import PropTypes from 'prop-types';

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var classnames = createCommonjsModule(function (module) {
  /*!
    Copyright (c) 2017 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */

  /* global define */
  (function () {
    var hasOwn = {}.hasOwnProperty;

    function classNames() {
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;
        var argType = typeof arg;

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg) && arg.length) {
          var inner = classNames.apply(null, arg);

          if (inner) {
            classes.push(inner);
          }
        } else if (argType === 'object') {
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }

      return classes.join(' ');
    }

    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
});
/**
 * BEM class name factory.
 *
 * @typedef {Function} Bem
 * @param {String|Object} [elementOrMods] Element name or hash object with mods
 * @param {Object} [mods] Hash object with mods
 * @returns {String}
 */

/**
 * Returns BEM class name factory.
 *
 * @param {String} componentName Block name
 * @returns {Bem}
 */

var easyBem = function bem(componentName) {
  return function (elementOrMods, mods) {
    if (!elementOrMods) {
      return componentName;
    }

    var element;

    if (typeof elementOrMods === 'string') {
      element = elementOrMods;
    } else {
      mods = elementOrMods;
    }

    if (process.env.NODE_ENV !== 'production') {
      if (element && typeof element !== 'string') {
        throw new Error('You must provide `element` as string');
      }

      if (mods && typeof mods !== 'object') {
        throw new Error('You must provide `mods` as plain object');
      }
    }

    var base = componentName;

    if (element) {
      base += '__' + element;
    }

    return base + (mods ? Object.keys(mods).reduce(function (result, name) {
      var value = mods[name];

      if (value) {
        result += ' ' + (typeof value === 'boolean' ? base + '--' + name : base + '--' + name + '_' + value);
      }

      return result;
    }, '') : '');
  };
};

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".indiana-scroll-container--dragging {\r\n  pointer-events: none;\r\n  cursor: grab;\r\n}\r\n\r\n.indiana-dragging {\r\n  cursor: grab !important;\r\n}";
styleInject(css);

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var cn = easyBem('indiana-scroll-container');

var ScrollContainer = function (_Component) {
  inherits(ScrollContainer, _Component);

  function ScrollContainer(props) {
    classCallCheck(this, ScrollContainer);

    var _this = possibleConstructorReturn(this, (ScrollContainer.__proto__ || Object.getPrototypeOf(ScrollContainer)).call(this, props));

    _this.onTouchStart = function (e) {
      if (_this.isDraggable(e.target)) {
        var touch = e.touches[0];
        _this.pressed = true;
        _this.clientX = touch.clientX;
        _this.clientY = touch.clientY;
        e.stopPropagation();
      }
    };

    _this.onTouchEnd = function (e) {
      _this.processEnd();
    };

    _this.onTouchMove = function (e) {
      if (_this.pressed) {
        var touch = e.touches[0];

        if (touch) {
          _this.processMove(touch.clientX, touch.clientY);

          if (e.preventDefault) {
            e.preventDefault();
          }
        }
      }
    };

    _this.onMouseDown = function (e) {
      if (_this.isDraggable(e.target)) {
        _this.pressed = true;
        _this.clientX = e.clientX;
        _this.clientY = e.clientY;
        e.stopPropagation();
      }
    };

    _this.onMouseMove = function (e) {
      if (_this.pressed) {
        _this.processMove(e.clientX, e.clientY, e);

        if (e.preventDefault) {
          e.preventDefault();
        }
      }
    };

    _this.onMouseUp = function (e) {
      if (e.preventDefault) {
        e.preventDefault();
      }

      e.stopPropagation();

      _this.processEnd();
    };

    _this.container = React.createRef();
    return _this;
  }

  createClass(ScrollContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('mouseup', this.onMouseUp);
      window.addEventListener('mousemove', this.onMouseMove);
      window.addEventListener('touchmove', this.onTouchMove);
      window.addEventListener('touchend', this.onTouchEnd);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('mouseup', this.onMouseUp);
      window.removeEventListener('mousemove', this.onMouseMove);
      window.removeEventListener('touchmove', this.onTouchMove);
      window.removeEventListener('touchend', this.onTouchEnd);
    }
  }, {
    key: 'isDraggable',
    value: function isDraggable(target) {
      var ignoreElements = this.props.ignoreElements;

      if (ignoreElements) {
        var closest = target.closest(ignoreElements);
        return closest === null || closest.contains(this.getElement());
      } else {
        return true;
      }
    }
  }, {
    key: 'getElement',
    value: function getElement() {
      return this.container.current;
    }
  }, {
    key: 'processMove',
    value: function processMove(newClientX, newClientY) {
      var _props = this.props,
          horizontal = _props.horizontal,
          vertical = _props.vertical,
          activationDistance = _props.activationDistance,
          onScroll = _props.onScroll,
          onStartScroll = _props.onStartScroll;
      var container = this.container.current;

      if (!this.dragging && this.pressed) {
        if (horizontal && Math.abs(newClientX - this.clientX) > activationDistance || vertical && Math.abs(newClientY - this.clientY) > activationDistance) {
          this.clientX = newClientX;
          this.clientY = newClientY;
          this.dragging = true;
          document.body.classList.add('indiana-dragging');

          if (onStartScroll) {
            onStartScroll();
          }

          this.forceUpdate();
        }
      }

      if (this.dragging) {
        if (horizontal) {
          container.scrollLeft -= newClientX - this.clientX;
        }

        if (vertical) {
          container.scrollTop -= newClientY - this.clientY;
        }

        if (onScroll) {
          onScroll(container.scrollLeft, container.scrollTop, container.scrollWidth, container.scrollHeight);
        }

        this.clientX = newClientX;
        this.clientY = newClientY;
      }
    }
  }, {
    key: 'processEnd',
    value: function processEnd() {
      var onEndScroll = this.props.onEndScroll;
      var container = this.container.current;
      this.pressed = false;
      this.dragging = false;
      document.body.classList.remove('indiana-dragging');

      if (onEndScroll) {
        onEndScroll(container.scrollLeft, container.scrollTop, container.scrollWidth, container.scrollHeight);
      }

      this.forceUpdate();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          className = _props2.className,
          style = _props2.style,
          hideScrollbars = _props2.hideScrollbars;
      return React.createElement('div', {
        className: classnames(className, cn({
          dragging: this.dragging
        })),
        style: _extends({}, style, {
          overflow: hideScrollbars ? 'hidden' : 'auto'
        }),
        ref: this.container,
        onTouchStart: this.onTouchStart,
        onMouseDown: this.onMouseDown
      }, children);
    }
  }]);
  return ScrollContainer;
}(Component);

ScrollContainer.propTypes = {
  vertical: PropTypes.bool,
  horizontal: PropTypes.bool,
  hideScrollbars: PropTypes.bool,
  activationDistance: PropTypes.number,
  children: PropTypes.node,
  onStartScroll: PropTypes.func,
  onScroll: PropTypes.func,
  onEndScroll: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
  ignoreElements: PropTypes.string
};
ScrollContainer.defaultProps = {
  hideScrollbars: true,
  activationDistance: 10,
  vertical: true,
  horizontal: true,
  style: {}
};
export default ScrollContainer;